import getData from '@services/api/common/getData';
import appConfig from '@configs/appConfig';
import { admin } from '@constants/appRoutes';

export const getTenants = () => getData(`${appConfig.baseUrl}${admin}Tenants`);

export const getInfo = tenantId =>
  getData(`${appConfig.baseUrl}${admin}${tenantId}/SmsUsage`);
